/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  AppDispatch,
} from '@utils/store';
import {
  useDispatch,
} from 'react-redux';

const useTypedDispatch: () => AppDispatch = useDispatch;

export default useTypedDispatch;
